import { formatText } from '../formatText'
import { Name } from './Name'
import { Person } from './Person'
import type { TContact } from '~/types/contact/models'
import {
  ContactTypeIds,
  getContactTypeById,
} from '~/services/selectLists/contactTypes'

export function Contact(o: TContact): TContact {
  const fn = '[cynqueModules/dataObjects/Contact.ts] Contact |'
  if (!o) {
    throw new Error(`${fn} Contact called with falsey contact`)
  }
  if (!o.person) {
    throw new Error(`${fn} Contact called with falsey contact.person`)
  }

  const obj = { ...o }

  if (!o.company && !o.supplier && !o.tsd && !o.leadSource) {
    throw new Error(
      `${fn} No company, supplier, tsd, or leadSource object in Contact.` +
        ' This is almost certainly a programming error.'
    )
  }
  obj.person = Person(o.person)
  const nameDescr = Name(o.person.name).descr ?? 'No Name'
  const phoneNumberToUse =
    o.phone ?? o.cell ?? o.person.phone ?? o.person.cell ?? 'No Phone'
  obj.label = nameDescr
  obj.descr = nameDescr + '\n' + phoneNumberToUse
  obj.type = o.company
    ? getContactTypeById(ContactTypeIds.COMPANY)
    : o.supplier
    ? getContactTypeById(ContactTypeIds.SUPPLIER)
    : o.tsd
    ? getContactTypeById(ContactTypeIds.TSD)
    : getContactTypeById(ContactTypeIds.LEAD_SOURCE)

  const avatarDescr = obj.person.name.initials ?? ''
  const avatarType = o.company
    ? 'companyContact'
    : o.supplier
    ? 'supplierContact'
    : o.tsd
    ? 'tsdContact'
    : 'leadSourceContact'
  obj.avatar = { descr: avatarDescr, type: avatarType }

  obj.parentName = o.company
    ? o.company.label
    : o.supplier
    ? o.supplier.label
    : o.tsd
    ? o.tsd.label // test above ensures tsd will not be undefined if company and supplier are
    : '--' // LeadSource has no parent

  obj.namePlusBiz =
    obj.type.id === ContactTypeIds.LEAD_SOURCE
      ? `${nameDescr} | Lead Source` + (o.title ? ' | ' + o.title : '')
      : `${nameDescr} | ${obj.parentName} | ` + (o.title ?? o.role?.label ?? '')

  if (o.phone || o.email) {
    obj.emailPlusPhone =
      (o.email ?? '') +
      (o.email ? '\n' : '') +
      (o.phone ? o.phone : '') +
      (o.phone && o.cell ? ' ... ' : '') +
      (o.cell ? o.cell + ' cell' : '')
  }

  obj.phonePlusCellDescr = formatText(o.phone) + '\n' + formatText(o.cell)

  console.debug(`${fn} returning`, obj)
  return obj
}
